import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { LayoutService } from '../../core/service/layout.service';
import { Router } from '@angular/router';
import { RevalidationStatus } from '../model/RevalidationStatus';
import { ExtCircService } from '../service/extCirc.service';

interface RemediationSummaryItem {
  revalidationSubmissionDate: string;
  revalidationStatus: RevalidationStatus;
  registrantCount: number;
}

interface RemediationSummaryRow {
  submissionDeadline: string;
  [status: string]: string | number;
}

@Component({
    templateUrl: './remediationDashboard.component.html',
    styleUrls: ['../list.scss', './remediationDashboard.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RemediationDashboardComponent implements OnInit {

  loading = false;
  data: RemediationSummaryRow[] = [];
  RevalidationStatus = RevalidationStatus;

  constructor(private router: Router, public layout: LayoutService, private service: ExtCircService) { }

  ngOnInit() {
    this.load();
  }

  showRegistrants(
    submissionDeadline: string,
    revalidationStatus: RevalidationStatus,
    totalCount: number
  ): void {
    this.router.navigate(['/revalidation/remediation/list', revalidationStatus, submissionDeadline], { queryParams: { totalCount }});
  }

  load() {
    this.loading = true;

    const process = (data: RemediationSummaryItem[]): RemediationSummaryRow[] => data.reduce((acc, item) => {
      const row = acc.find(r => r.submissionDeadline === item.revalidationSubmissionDate);
      if (row) {
        row[RevalidationStatus[item.revalidationStatus]!] = item.registrantCount;
      } else {
        const newRow: RemediationSummaryRow = { submissionDeadline: item.revalidationSubmissionDate };
        newRow[RevalidationStatus[item.revalidationStatus]!] = item.registrantCount;
        acc.push(newRow);
      }
      return acc;
    }, [] as any[]);

    this.service.getRemediationSummary().subscribe(data => {
      this.data = process(data);
      this.data = this.data.sort((a, b) => {
        return new Date(a.submissionDeadline) > new Date(b.submissionDeadline) ? -1 : 1;
      });
      this.loading = false;
    });
  }



}
